// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';

export default css`
  ${(props) =>
    props.spc && !props.isMobileWebProductTileCheckout && !props.hasExpeditedProcessing
      ? `margin-bottom: ${props.theme.spacing.ELEM_SPACING.LRG};`
      : ''}
  .sth-icon {
    width: 26px;
    height: 22px;
    vertical-align: bottom;
    margin-right: 4px;
    ${(props) => (props.newBag ? 'vertical-align:middle;margin-right:7px;' : '')}
  }
  .estimated-shipping-speed {
    padding-left: ${(props) => (!props.spc ? '40px' : '0px')};

    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding: 0;
    }
  }

  .estimated-shipping-date {
    padding-left: 5px;
    white-space: nowrap;
    display: inline-block;
  }

  .myBagSpc {
    padding-top: ${(props) => props.theme.spacing.APP_LAYOUT_SPACING.XS};
  }
  .subtitle {
    text-transform: capitalize;
    padding: 0;
    text-align: center;
    color: ${(props) => props.theme.colors.NOTIFICATION.SUCCESS};
  }
  .holiday-message-wrapper {
    display: flex;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs12};
    }
  }
  .edd-wrapper-new-tile {
    display: flex;
  }
  .color-fit-size-separator {
    margin-top: 22px;
  }
`;

export const ExpeditedBenefit = styled.div`
  display: inline-block;
  padding: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS}
    ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
  border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS};
  background: ${(props) => props.theme.colorPalette.gray[300]};
  margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS};
  margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED_1};

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    margin-bottom: 0;
  }

  .expedited-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
  }
`;
